import { IMilestoneBase, IMilestoneTemplate, IProject } from "@/interfaces";
import { getNestedMilestones, getTopLevelMilestones } from "./helper";

export interface IGetMilestones {
  isTemplate: boolean;
  milestoneTemplates: IMilestoneTemplate[];
  project: IProject;
  flattenedMilestones: IMilestoneBase[];
  parentId: string;
}

export const getAvailableMilestones = (
  parameters: IGetMilestones
): IMilestoneBase[] =>
  parameters.parentId
    ? getNestedMilestones(parameters)
    : getTopLevelMilestones(parameters);
